/**
 * @see https://www.figma.com/file/9ZaP38wT1DHgDfFM9xWCDq/CERTI-02-Homepage?type=design&node-id=21-4384&mode=design&t=dydGvMJZDrnTsFLS-0
 */
/* eslint-disable */
import Aisanaidt from './svgs/logo-aisanaidt.svg';
import Coupang from './svgs/logo-coupang.svg';
import Hd from './svgs/logo-hd.svg';
import Hyundaicapital from './svgs/logo-hyundaicapital.svg';
import Kbbank from './svgs/logo-kbbank.svg';
import Kbdatasystem from './svgs/logo-kbdatasystem.svg';
import Korcham from './svgs/logo-korcham.svg';
import Koreanair from './svgs/logo-koreanair.svg';
import Kyobo from './svgs/logo-kyobo.svg';
import Lgcns from './svgs/logo-lgcns.svg';
import Likelion from './svgs/logo-likelion.svg';
import Madup from './svgs/logo-madup.svg';
import Meritz from './svgs/logo-meritz.svg';
import Nhncrossent from './svgs/logo-nhncrossent.svg';
import Poscodx from './svgs/logo-poscodx.svg';
import Shinhan from './svgs/logo-shinhan.svg';
import Yogiyo from './svgs/logo-yogiyo.svg';
import Dbinc from './images/logo-dbinc.png';
import Doodlin from './images/logo-doodlin.png';
import Moloco from './images/logo-moloco.png';
import Nhinfosystem from './images/logo-nhinfosystem.png';
import Polarisoffice from './images/logo-polarisoffice.png';
import Shinsegae from './images/logo-shinsegae.png';
import Skcnc from './images/logo-skcnc.png';
/* eslint-disable */

import styled from '@emotion/styled';
import Image from 'next/image';
import AutoSwiper from '@/components/comm/AutoSwiper';

type Props = {
  group: 'first' | 'second' | 'both';
  direction?: 'right' | 'left';
};

const PartnerLogoAnimation = ({group, direction = 'left'}: Props) => {
  const firstGroup = [
    [Coupang, '쿠팡'],
    [Madup, 'Madup'],
    [Kyobo, '교보생명'],
    [Koreanair, '대한항공'],
    [Shinhan, '신한라이프'],
    [Yogiyo, '요기요'],
    [Hyundaicapital, '현대캐피탈'],
    [Nhinfosystem, '농협정보시스템'],
    [Nhncrossent, 'NHN Crossent'],
    [Dbinc, 'DB Inc'],
    [Poscodx, '포스코디엑스'],
    [Aisanaidt, '아시아나IDT'],
  ];

  const secondGroup = [
    [Lgcns, 'LG CNS'],
    [Moloco, 'MOLOCO'],
    [Skcnc, 'SK C&C'],
    [Doodlin, '두들린'],
    [Polarisoffice, '폴라리스 오피스'],
    [Kbbank, 'KB국민은행'],
    [Kbdatasystem, 'KB데이터시스템'],
    [Meritz, '메리츠화재'],
    [Shinsegae, '신세계 I&C'],
    [Hd, 'HD한국조선해양'],
    [Likelion, 'LIKELION'],
    [Korcham, '대한상공회의소'],
  ];

  return (
    <AutoSwiper
      height={120}
      itemGap={80}
      animation={{delay: 0.5, direction, pixelPerSecond: 96 / 1.5}}
    >
      {(group === 'first' && firstGroup ||
       group === 'second' && secondGroup ||
       [...firstGroup, ...secondGroup])
      .map((item) => <Item key={item[1]}><Image src={item[0]} alt={item[1]} loading="eager" /></Item>)}
    </AutoSwiper>
  );
};

export default PartnerLogoAnimation;

const Item = styled.li`
    height: 100%;

    > img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
`;
